import {
  ADD_TABLE_POS,
  GET_TABLE_POS,
  UPDATE_TABLE_POS,
  DELETE_TABLE_POS,
  ADD_SECTION_POS,
  GET_SECTION_POS,
  UPDATE_SECTION_POS,
  DELETE_SECTION_POS,
  GET_SETTINGS_POS,
  CREATE_BUSINESS_POS,
  SET_LOADING_POS,
  SET_IS_BEEPING,
  LAST_CREATED_TABLE_POS,
  LAST_CREATED_SECTION_POS,
  GET_PROMOTIONS_POS,
  ADD_PROMOTION_POS,
  UPDATE_PROMOTION_POS,
  DELETE_PROMOTION_POS,
  GET_COUPONS_POS,
  SET_COUPONS_POS,
} from 'redux/actions/types';

const initialState = {
  business: {},
  tables: [],
  sections: [],
  promotions: [],
  coupons: [],
  loading: false,
  isBeeping: false,
  isSectionEmpty: false,
  lastCreatedTable: null,
  lastCreatedSection: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LAST_CREATED_TABLE_POS:
      return { ...state, lastCreatedTable: payload };
    case LAST_CREATED_SECTION_POS:
      return { ...state, lastCreatedSection: payload };
    case ADD_TABLE_POS:
      return { ...state, tables: payload };
    case GET_TABLE_POS:
      return { ...state, tables: payload };
    case DELETE_TABLE_POS:
      return { ...state, tables: payload };
    case UPDATE_TABLE_POS:
      return { ...state, tables: payload };
    case ADD_SECTION_POS:
      return {
        ...state,
        sections: payload,
      };
    case GET_SECTION_POS:
      return { ...state, 
        sections: payload, 
        isSectionEmpty: Boolean(payload?.length === 0) 
      };
    case DELETE_SECTION_POS:
      return { ...state, sections: payload };
    case UPDATE_SECTION_POS:
      return { ...state, sections: payload };
    case CREATE_BUSINESS_POS:
      return { ...state, business: payload };
    case GET_SETTINGS_POS:
      return { ...state, settings: payload };
    case SET_LOADING_POS:
      return { ...state, loading: payload };
    case SET_IS_BEEPING:
      return { ...state, isBeeping: payload };
    case GET_PROMOTIONS_POS:
      return { ...state, promotions: payload };
    case ADD_PROMOTION_POS:
      return { ...state, promotions: payload };
    case UPDATE_PROMOTION_POS:
      return { ...state, promotions: payload };
    case DELETE_PROMOTION_POS:
      return { ...state, promotions: payload };
    case GET_COUPONS_POS:
      return { ...state, coupons: payload };
    case SET_COUPONS_POS:
      return { ...state, coupons: payload };
    default:
      return state;
  }
};
